import VueI18n from "vue-i18n";
import { Input } from "element-ui";

function isAscii(c: string) {
    let cc = c.charCodeAt(0);
    return cc > 0 && cc < 255;
}

function filterString(s: string, fn: any) {
    if (!s) {
        return s;
    }
    let res = [];
    for (let c of s) {
        if (fn(c)) {
            res.push(c);
        }
    }
    return res.join("");
}
/**
 * 英文状态下不许输入ascii之外的文字
 * **6.2月会shen总提出**
 */
export function hackInput(i18n: VueI18n) {
    function addInputHandler(input: any) {
        const rawMounted = input.mounted


        input.mounted = function () {
            rawMounted.call(this)
            let input = this.$refs['input']
            if (this.$props.type === 'textarea') {
                input = this.$refs['textarea']
            }
            let filterCn = () => {
                if (i18n.locale === 'en') {
                    let value = filterString(this.value, isAscii)
                    this.$emit('input', value)
                }
            }
            if (input) {
                input.addEventListener('keyup', filterCn)
                input.addEventListener('pause', filterCn)
            }
        }
    }
    addInputHandler(Input)
}
